import createAction from '@clearscore/helpers.create-action';

export const trackRequestFailed = (TYPE) => (failedApiName, errorPath) =>
    createAction(TYPE, { context: { failedApiName, errorPath } });

export const trackReportNotFound = (TYPE) => (errorPath) => createAction(TYPE, { context: { errorPath } });
